import * as PANOLENS from 'panolens';
import { SphereBufferGeometry } from 'three';
import { Button } from 'antd';
import { useEffect } from 'react';
import Panorama from '&/components/Panorama';
import PanoramaEditPanel from '@/components/PanoramaEditPanel/index';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import {
    createHotSpot,
    deleteHotSpot,
    editHotSpot as editHotSpotApi,
    getAlbumList,
    getVirtualRoomAlbumList,
    createShare,
} from '@/api/hdd/album';

import './PanoramaEdit.scss';

export default function PanoramaEdit(props) {
    const renderId = new URLSearchParams(window.location.search).get('id');

    const editType = new URLSearchParams(window.location.search).get('type');

    const [active, setActive] = useState(0);

    const [tipPosition, setTipPosition] = useState([]);

    const vrRoomData = useRef({ data: {} });

    const [vrRoomHotList, setVrRoomHotList] = useState([]);

    usePreventDefault();

    function formatSpot(spot) {
        spot.infospot = new PANOLENS.Infospot(1, '', false);
        spot.infospot.material.visible = false;
        spot.infospot.userData.changePosition = true;
        let position = JSON.parse(spot.coordinate);
        spot.infospot.position.set(position[0], position[1], position[2]);
        spot.text = spot.title;
        spot.styleType = spot.style === 'black' ? 1 : 2;
        spot.picture = spot.illustration;
        spot.desc = spot.description;
    }

    useEffect(() => {
        if (editType === 'panorama') {
            getAlbumList({ renderId }).then(res => {
                if (!res.data || !res.data.list) {
                    return;
                }
                const [item] = res.data.list;
                let tipList = res.data.list.map(item => {
                    const panorama = new PANOLENS.ImagePanorama(
                        item.renderUrl,
                        new SphereBufferGeometry(5000, 128, 108)
                    );
                    item.panorama = panorama;
                    return item;
                });
                setTipPosition(tipList);

                let list = item.hotSports.map(spot => {
                    formatSpot(spot);
                    return spot;
                });
                setHotList(list);
            });
        } else {
            getVirtualRoomAlbumList({ renderId, getSpace: 1 }).then(res => {
                if (!res || !res.data || !res.data.list) {
                    return;
                }
                const [vrRoom] = res.data.list;

                let hotSpotMap = {};

                let renderList = Object.entries(vrRoom.render).map(
                    ([key, value]) => {
                        const panorama = new PANOLENS.ImagePanorama(
                            value.renderUrl,
                            new SphereBufferGeometry(5000, 128, 108)
                        );
                        let hopSpotList = vrRoom.hotSports[key].map(spot => {
                            formatSpot(spot);
                            spot.targetPanorama = panorama;
                            return spot;
                        });
                        hotSpotMap[key] = hopSpotList;
                        vrRoomData.current = hotSpotMap;
                        return {
                            ...value,
                            id: key,
                            panorama,
                            hopSpotList,
                        };
                    }
                );

                setTipPosition(renderList);

                setVrRoomHotList([...renderList]);
                setHotList(vrRoomData.current[renderList[active].id]);
            });
        }
    }, []);

    const [hotList, setHotList] = useState([]); // 热点列表

    const handleAddHot = hot => {
        return createHotSpot({
            renderId: tipPosition[active].id,
            type: 1,
            style: hot.styleType === 1 ? 'black' : 'white',
            title: hot.text,
            description: hot.desc,
            from: 1,
            illustration: hot.picture
                ? new URL(hot.picture)?.pathname?.substring(1)
                : undefined,
            illustrationFrom: hot.illustrationFrom,
            coordinate: JSON.stringify([]),
        }).then(res => {
            hot.id = res.data.item.id;
            hot.infospot = new PANOLENS.Infospot(1, '', false);
            hot.infospot.material.visible = false;
            hot.renderId = tipPosition[active].id;
            if (editType === 'panoramaVrRoom') {
                if (!vrRoomHotList[active]['hopSpotList']) {
                    vrRoomHotList[active]['hopSpotList'] = [];
                    vrRoomHotList[active]['hopSpotList'].push(hot);
                } else {
                    vrRoomHotList[active]['hopSpotList'].push(hot);
                }
                setVrRoomHotList([...vrRoomHotList]);
                setHotList([...vrRoomHotList[active]['hopSpotList']]);
            } else {
                setHotList(prev => [...prev, hot]);
            }
        });
    };

    const [controlPosition, setControlPosition] = useState(); // 相机位置

    const setCameraPosition = position => {
        console.log('panorama', tipPosition[active].panorama);
        setControlPosition(position);
    };

    const handleEditHotSpot = (payload, vrRoomIndex) => {
        let nextVrRoomHotList;
        if (editType === 'panoramaVrRoom') {
            nextVrRoomHotList = vrRoomHotList[vrRoomIndex].hopSpotList;
            let index = nextVrRoomHotList.findIndex(
                item => item.id === payload.id
            );

            nextVrRoomHotList[index] = {
                ...nextVrRoomHotList[index],
                ...payload,
            };
        }

        let next = [...hotList];

        let index = next.findIndex(item => item.id === payload.id);

        next[index] = { ...next[index], ...payload };

        return editHotSpotApi({
            hotspotsId: payload.id,
            style: payload.styleType === 1 ? 'black' : 'white',
            title: payload.text,
            description: payload.desc,
            illustration: payload.picture
                ? new URL(payload.picture)?.pathname?.substring(1)
                : undefined,
            illustrationFrom: payload.illustrationFrom,
            render3dId: editType === 'panoramaVrRoom' ? renderId : undefined,
        }).then(res => {
            if (editType === 'panoramaVrRoom') {
                vrRoomHotList[vrRoomIndex]['hopSpotList'] = nextVrRoomHotList;
                setVrRoomHotList([...vrRoomHotList]);
                setHotList([...nextVrRoomHotList]);
            } else {
                setHotList(next);
            }
        });
    };

    const handleDeleteHotSpot = id => {
        deleteHotSpot({ hotSpotId: id }).then(() => {
            let next = [...hotList];
            let index = next.findIndex(item => item.id === id);
            let deleteItem = next.splice(index, 1);
            deleteItem[0].infospot.element.removeEventListener(
                'mousedown',
                deleteItem[0].infospot.userData.mousedownFn
            );
            deleteItem[0].infospot.dispose();
            setHotList(next);
            if (editType === 'panoramaVrRoom') {
                vrRoomHotList[active]['hopSpotList'] = vrRoomHotList[active][
                    'hopSpotList'
                ].filter(v => v.id !== id);
                setVrRoomHotList([...vrRoomHotList]);
            }
        });
    };

    const onPanoramaChange = index => {
        setActive(index);
        console.log(
            'vrRoomData.current[tipPosition[index].id]',
            vrRoomData.current[tipPosition[index].id]
        );
        setHotList(vrRoomData.current[tipPosition[index].id]);
    };

    const onGoBack = () => {
        props.history.goBack();
    };

    const handleOpenBrowser = () => {
        createShare({
            renderId,
            type: editType === 'panorama' ? 1 : 2,
        }).then(res => {
            if (!res.data) return;
            let url = `${window.location.host}/hdd/panoramaShare?shareCode=${
                res.data.shareCode
            }&panorama=${editType === 'panorama' ? 0 : 1}`;
            console.log('url', url);
            try {
                window.external.DispatchFun('Atlas', 'OpenBrowser', url);
            } catch (error) {
                Promise.reject(error);
                console.log(error);
            }
        });
    };

    return (
        <div className="photo-panorama-edit">
            <div className="header">
                <div>
                    {editType === 'panoramaVrRoom' ? '全屋漫游图' : '全景图'}
                    编辑
                </div>
                <div className="operate-btn-wrap">
                    {/* <Button className="save" type="primary">
                        保存
                    </Button> */}
                    <Button className="delete" onClick={handleOpenBrowser}>
                        浏览器查看
                    </Button>
                    <Button className="exit" type="primary" onClick={onGoBack}>
                        完成编辑
                    </Button>
                </div>
            </div>
            <div className="content">
                <div className="left-preview">
                    <Panorama
                        tipPosition={tipPosition}
                        hotList={hotList}
                        current={active}
                        setCurrent={setActive}
                        active={active}
                        onPanoramaChange={onPanoramaChange}
                        // showSpot={true}
                        autoRotate={false}
                        isHotMove={true}
                        isHotClick={false}
                        showAllHouse={editType === 'panoramaVrRoom'}
                        isVrRoomEdit={true}
                        controlPosition={controlPosition}
                        setControlPosition={setControlPosition}
                        noZoom
                        render3dId={
                            editType === 'panoramaVrRoom' ? renderId : undefined
                        }
                    />
                </div>
                <PanoramaEditPanel
                    handleAddHot={handleAddHot}
                    handleEditHotSpot={handleEditHotSpot}
                    handleDeleteHotSpot={handleDeleteHotSpot}
                    hotList={hotList}
                    active={active}
                    setActive={setActive}
                    vrRoomHotList={vrRoomHotList}
                    setVrRoomHotList={setVrRoomHotList}
                    tipPosition={tipPosition}
                    onPanoramaChange={onPanoramaChange}
                    setCameraPosition={setCameraPosition}
                />

                <div
                    className={`footer-left-userInfo ${
                        editType === 'panorama' ? 'panorama-footer' : ''
                    }`}>
                    <img src={tipPosition?.[active]?.headUrl}></img>
                    <div
                        className="name text-no-wrap"
                        title={tipPosition?.[active]?.username}>
                        {tipPosition?.[active]?.username}
                    </div>
                </div>
                <div
                    className={`footer-right-btn  ${
                        editType === 'panorama' ? 'panorama-footer' : ''
                    }`}>
                    <img
                        src={
                            require('&/assets/img/hdd/Group710.png').default
                        }></img>
                    <div>扫码分享</div>
                </div>
            </div>
        </div>
    );
}
